var AddChargeBookingController = /** @class */ (function () {
    function AddChargeBookingController($scope, $state, $mdDialog, $timeout, $q, 
        $stateParams, $mdPanel, chargeBookingsService, $loading, $message, 
        $ionicScrollDelegate, localStorageService, AuthService, $translationService) {

        this.$scope = $scope;
        this.$state = $state;
        this.$mdDialog = $mdDialog;
        this.$timeout = $timeout;
        this.$q = $q;
        this.$stateParams = $stateParams;
        this.$mdPanel = $mdPanel;
        this.chargeBookingsService = chargeBookingsService;
        this.$loading = $loading;
        this.$message = $message;
        this.$ionicScrollDelegate = $ionicScrollDelegate;
        this.localStorageService = localStorageService;
        this.AuthService = AuthService;
        this.$translationService = $translationService;
        
        this.panelRef = null;

        // NF-806: hide km
        this.hideAutonomyEstimation = false;

        this.item = {
            NeededChargePercentage: 0,
            NeededChargeExpressedInKm: 0,
            VehicleAutonomyOnFullCharge: 0
        };
        // Check data loaded
        this.loaded = false;
        this.editable = true; // true: Add, Edit  -   false: Details
        // Date
        this.date = moment().format('YYYY-MM-DD');
        this.startTime = 8;
        this.endTime = 20;
        this.isShowWarningChargePercentagePerHour = false;
        this.$scope.vm = this;
        this.$element = $('#internal-add-charge-booking-page');
        this.watch();
        this.onInit();
    }
    Object.defineProperty(AddChargeBookingController.prototype, "ChargeStatus", {
        get: function () {
            return ChargeStatus;
        },
        enumerable: false,
        configurable: true
    });
    AddChargeBookingController.prototype.onInit = function () {
        var _this = this;
        var state = this.$stateParams.state ? JSON.parse(this.$stateParams.state) : {};
        this.item.Id = this.$stateParams.id;
        if (this.item.Id) {
            // Edit | Detail
            this.item.Editable = state.item.Editable;
        }
        else {
            // Add
            this.item.Editable = true;
        }
        this.checkStatus(this.item);
        this.hours = this.getHours();
        this.getData().then(function (item) {
            _this.plannedArrivalTime = _this.chargeBookingsService.hourToNumber(item.StartTime) || _this.startTime;
            _this.plannedDepartureTime = _this.chargeBookingsService.hourToNumber(item.EndTime) || _this.startTime;
            _this.date = moment(item.StartDate).format('YYYY-MM-DD');
            _.extend(_this.item, item);
            _this.checkStatus(_this.item);
            // Allow render
            _this.loaded = true;
            //Prevent scroll when slide slider
            _this.$timeout(function () {
                _this.preventScroll(_this.$element.find('md-slider'));
            }, 100);
        });

        // NF-519
        this.currentSiteId = null;

        this.sites = [];
        this.isMultiSites = false;

        var user = this.AuthService.getAuthenticatedUser();        

        // NF-806
        if (user) {
            this.hideAutonomyEstimation = user.HideAutonomyEstimationForChargeOnMobile;
        }

        if (user && user.Sites) {
            this.isMultiSites = true;
            this.sites = _.filter(user.Sites, x => x.ChargeBookingEnabled);

            if (this.sites.length == 0) {
                var msg = this.$translationService.getTranslation('NoVisibleSiteSupportChargeBooking');

                noBookingSite = this.$mdDialog.alert()
                // .textContent("There is no visible site can support charge booking.")
                .textContent(msg)
                .ok(this.$translationService.getTranslation('OK'))
                .clickOutsideToClose(true);

                this.$mdDialog.show(noBookingSite).then(function () {
                    _this.back();
                });

                return;
            }

            this.restoreState();
            if (!this.currentSiteId) {
                this.currentSiteId = this.sites[0].Id;
                this.saveState();
            }
        } else {
            // in case user not in multisite any more (come from multi sites) we reset data saved before
            this.saveState();
        }
    };
    AddChargeBookingController.prototype.save = function (form) {
        var _this = this;
        if (!this.isValid(form)) {
            return;
        }
        var data = this.prepareDataToSave();
        this.$loading.show();
        this.chargeBookingsService.saveChargeBooking(data)
            .finally(function () {
                _this.$loading.hide();
            })
            .then(function (res) {
                var bookingOK = null;
                // NF-156: show result message in case server return a charging point
                if (res && res.ChargingPoint) {
                    bookingOK = _this.$mdDialog.alert()
                        // .textContent(`The charge booking has been recorded and assigned for charging point "${res.ChargingPoint}".`)
                        .textContent(_this.$translationService.formatTranslation('ChargeBookingRecordedAndAssigned', res.ChargingPoint))
                        .ok(_this.$translationService.getTranslation('OK'))
                        .clickOutsideToClose(true);
                } else {
                    bookingOK = _this.$mdDialog.alert()
                        // .textContent(`The charge booking has been recorded but there is not charging point available at this time and therefor the charge booking is in the waiting list.`)
                        .textContent(_this.$translationService.getTranslation('ChargeBookingRecordedAndNotAssigned'))
                        .ok(_this.$translationService.getTranslation('OK'))
                        .clickOutsideToClose(true);
                }

                _this.$mdDialog.show(bookingOK).then(function () {
                    _this.back();
                });
            });
    };
    /**
     * Check data before send to send to server
     * @private
     */
    AddChargeBookingController.prototype.isValid = function (form) {
        // NeededChargePercentage is required
        if (!this.item.NeededChargePercentage) {
            this.$message.error("Please input the Minimum Power Needed (charge to be added).");
            return false;
        }
        // plannedDepartureTime <= plannedArrivalTime
        if (this.plannedDepartureTime <= this.plannedArrivalTime) {
            this.$message.error("Please select the Expected Arrival Time and Expected Departure Time.");
            return false;
        }
        // Max-Length for description
        if (form.description.$invalid) {
            this.$message.error("The Description exceed maximum length.");
            return false;
        }
        return true;
    };
    AddChargeBookingController.prototype.back = function () {
        this.$state.go('internal.chargebookings');
    };
    /**
     * Increase NeedPower to max
     */
    AddChargeBookingController.prototype.increaseToMax = function () {
        this.item.NeededChargePercentage = 100;
    };
    /**
     * Show date picker
     * @param $event
     * @param item
     * @param name
     * @param options
     */
    AddChargeBookingController.prototype.showDatePickerModal = function ($event, item, name, options) {
        var _this = this;
        var DatePickerDialogController = /** @class */ (function () {
            function DatePickerDialogController(mdPanelRef, date, options, onClose) {
                this.mdPanelRef = mdPanelRef;
                this.date = date;
                this.onClose = onClose;
                this.minDate = moment();
                this.maxDate = moment().add(1, "months");
                this.options = options;
            }
            DatePickerDialogController.prototype.onChange = function (key, value) {
                if (key === 'selected-day') {
                    var date = value.format('YYYY-MM-DD');
                    this.closePanel(date);
                }
            };
            DatePickerDialogController.prototype.onTodayButtonClicked = function () {
                var date = moment().format('YYYY-MM-DD');
                this.closePanel(date);
            };
            DatePickerDialogController.prototype.onClearButtonClicked = function () {
                //@ts-ignore
                this.date = null;
                this.closePanel(this.date);
            };
            DatePickerDialogController.prototype.closePanel = function (data) {
                var _this = this;
                this.mdPanelRef.close().then(function () {
                    _this.onClose(data);
                });
            };
            DatePickerDialogController.prototype.onCancel = function () {
                this.mdPanelRef.close();
            };
            return DatePickerDialogController;
        }());
        var config = {
            controller: DatePickerDialogController,
            controllerAs: 'vm',
            templateUrl: 'js/internal/addevent-v2/date.modal.html',
            targetEvent: $event,
            clickOutsideToClose: true,
            escapeToClose: true,
            hasBackdrop: true,
            panelClass: 'add-charge-booking-date-panel',
            zIndex: 90,
            onDomAdded: function () {
                $('.add-charge-booking-date-panel').parent().addClass('add-event-v2-date-panel-container');
            },
            locals: {
                onClose: function (date) {
                    item[name] = date;
                },
                date: moment(item[name], 'YYYY-MM-DD'),
                options: options
            }
        };
        this.$timeout(function () {
            _this.panelRef = _this.$mdPanel.create(config);
            _this.panelRef.open();
        }, 100);
    };
    /**
     * Trigger when click on delete button at right button to delete current charge booking
     */
    AddChargeBookingController.prototype.onDeleteChargeBookingClick = function ($event) {
        var _this = this;
        this.chargeBookingsService.showConfirmDeleteChargeBooking($event).then(function () {
            var item = _this.item;
            _this.$loading.show();
            _this.chargeBookingsService.deleteChargeBooking(item.Id)
                .finally(function () {
                    _this.$loading.hide();
                })
                .then(function () {
                    _this.back();
                });
        });
    };
    AddChargeBookingController.prototype.checkStatus = function (item) {
        this.editable = true;
        if (item.Id) {
            if (item.Editable) {
                this.title = this.$translationService.getTranslation('EditChargeBooking') // 'EDIT CHARGE BOOKING';
            }
            else {
                this.title = this.$translationService.getTranslation('ChargeBookingDetails') //'CHARGE BOOKING DETAILS';
                this.editable = false;
            }
        }
        else {
            this.title = this.$translationService.getTranslation('AddChargeBooking');  //'ADD CHARGE BOOKING';
        }
    };
    AddChargeBookingController.prototype.getData = function () {
        var state = this.$stateParams.state ? JSON.parse(this.$stateParams.state) : {};
        if (this.$stateParams.id) {
            return this.chargeBookingsService.getChargeBooking(this.$stateParams.id);
        }
        else {
            return this.$q(function (resolve) {
                var vehicle = state.vehicle;
                var item = {
                    VehicleId: vehicle.Id,
                    VehicleName: vehicle.Name,
                    VehicleModel: vehicle.Model,
                    VehicleAutonomyOnFullCharge: vehicle.VehicleAutonomyOnFullCharge,
                    MaxChargePercentagePerHour: vehicle.MaxChargePercentagePerHour
                };
                resolve(item);
            });
        }
    };
    /**
     * Get hours to input for time control
     * @private
     */
    AddChargeBookingController.prototype.getHours = function () {
        var hours = [];
        this.strStartTime = moment(moment().format('YYYY-MM-DD')).add(this.startTime, 'hours').format('HH:mm');
        this.strEndTime = moment(moment().format('YYYY-MM-DD')).add(this.endTime, 'hours').format('HH:mm');
        for (var i = this.startTime + 1; i < this.endTime; i = i + 1) {
            var label = '';
            if (i === 12)
                label = moment(moment().format('YYYY-MM-DD')).add(i, 'hours').format('HH');
            hours.push({
                label: label,
                left: (i - this.startTime) / (this.endTime - this.startTime) * 100
            });
        }
        return hours;
    };
    /**
     * Prevent scroll when slide
     * @param element
     */
    AddChargeBookingController.prototype.preventScroll = function (element) {
        var _this = this;
        element.on('touchstart mousedown', function () {
            _this.$ionicScrollDelegate.freezeAllScrolls(true);
        });
        element.on('touchend mouseup', function () {
            setTimeout(function () {
                _this.$ionicScrollDelegate.freezeAllScrolls(false);
            }, 100);
        });
    };
    /**
     * Update item, check warning when drag time, date
     * @private
     */
    AddChargeBookingController.prototype.watch = function () {
        var _this = this;
        // Arrival Time
        this.$scope.$watch('vm.plannedArrivalTime', function (plannedTime) {
            _this.arrivalTimePercent = (plannedTime - _this.startTime) / (_this.endTime - _this.startTime) * 100;
            _this.arrivalTimeHour = moment(moment().format('YYYY-MM-DD')).add(plannedTime, 'hours').format('HH:mm');
            _this.checkOverChargePercentagePerHour();
        });
        // Departure Time
        this.$scope.$watch('vm.plannedDepartureTime', function (plannedTime) {
            _this.departureTimePercent = (plannedTime - _this.startTime) / (_this.endTime - _this.startTime) * 100;
            _this.departureTimeHour = moment(moment().format('YYYY-MM-DD')).add(plannedTime, 'hours').format('HH:mm');
            _this.checkOverChargePercentagePerHour();
        });
        // Minimum Power Needed
        this.$scope.$watch('vm.item.NeededChargePercentage', function (charged) {
            _this.item.NeededChargeExpressedInKm = Math.round((charged / 100) * _this.item.VehicleAutonomyOnFullCharge);
            _this.checkOverChargePercentagePerHour();
        });
        this.$scope.$on('$destroy', function () {
            if(_this.panelRef){
                _this.panelRef.close();
            }
        });
    };
    /**
     * Prepare data
     * @private
     */
    AddChargeBookingController.prototype.prepareDataToSave = function () {
        var item = {};
        _.extend(item, this.item);
        _.extend(item, {
            // Arrival Time
            StartDate: this.date,
            StartTime: this.chargeBookingsService.hourToString(this.plannedArrivalTime),
            // Departure Time
            EndDate: this.date,
            EndTime: this.chargeBookingsService.hourToString(this.plannedDepartureTime)
        });

        if (this.isMultiSites) {
            _.extend(item, {
                SiteId: this.currentSiteId
            });
        }
        return item;
    };
    
    /**
     * Check display warning ChargePercentagePerHour
     * @private
     */
    AddChargeBookingController.prototype.checkOverChargePercentagePerHour = function () {
        if (!this.item.MaxChargePercentagePerHour) {
            this.isShowWarningChargePercentagePerHour = false;
        }
        else {
            var expectedDurationOnSite = this.plannedDepartureTime - this.plannedArrivalTime;
            if (expectedDurationOnSite <= 0) { // time is invalid
                this.isShowWarningChargePercentagePerHour = false;
            }
            else {
                var requiredChargeDuration = this.item.NeededChargePercentage / this.item.MaxChargePercentagePerHour;
                this.isShowWarningChargePercentagePerHour = requiredChargeDuration > expectedDurationOnSite;
            }
        }
    };
    AddChargeBookingController.prototype.onSiteChanged = function () {
        this.saveState();
    },
    AddChargeBookingController.prototype.saveState = function () {
        let state = {
            currentSiteId: this.currentSiteId
        }
        this.localStorageService.set("charge-booking", state);
    },
    AddChargeBookingController.prototype.restoreState = function () {
        let state = this.localStorageService.get("charge-booking");
        if (state) {
            this.currentSiteId = state.currentSiteId;
            if (this.sites) {
                let index = this.sites.findIndex(x => x.Id === this.currentSiteId);

                // in case the save site is not available anymore, we dont try to restore it
                if (index < 0) {
                    this.currentSiteId = null;
                }
            }
        } else {
            this.currentSiteId = null;
        }
    }

    AddChargeBookingController.$inject = [
        '$scope',
        '$state',
        '$mdDialog',
        '$timeout',
        '$q',
        '$stateParams',
        '$mdPanel',
        'ChargeBookingsService',
        '$Loading',
        "$message",
        "$ionicScrollDelegate",
        "localStorageService",
        "AuthService",
        "$translationService"
    ];
    return AddChargeBookingController;
}());
